import React from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import TooltipWrapper from '../TooltipWrapper';
import Loading from "../Loading";

class AccordionWrapper extends React.Component {
  state = { isAccordionActive: !this.props.collapsed };

  componentWillReceiveProps(newProps) {
    if (this.props.collapsed !== newProps.collapsed) {
      this.setState({
        isAccordionActive: !newProps.collapsed
      });
    }
  }

  handleClick = () => {
    if (this.props.closable) {
      const { isAccordionActive } = this.state;
      const newIsAccordionActive = !isAccordionActive;
      this.setState({ isAccordionActive: newIsAccordionActive });
    }
  };

  getClosableIcon = icon => {
    if (this.props.closable) {
      if (icon === null) {
        return <Icon name="dropdown" />;
      } else {
        return <Icon name={icon} />;
      }
    }
    return null;
  };

  render() {
    const { isAccordionActive } = this.state;
    const { className, titleClassName, contentClassName, tooltip, icon, t, accordionTitle, isContentLoading, accordionTitleIcon } = this.props;
    const closableIcon = this.getClosableIcon(icon);

    return (
      <Accordion fluid styled className={className}>
        <Loading isLoading={isContentLoading} />
        <Accordion.Title
          active={isAccordionActive}
          onClick={this.handleClick}
          className={titleClassName}
        >
          {closableIcon}
					{accordionTitleIcon}
          {tooltip && <TooltipWrapper tooltip={tooltip} />}
          {typeof(accordionTitle) == 'function' ? accordionTitle({closableIcon}) : t(accordionTitle)}
          {this.props.isRequired && <strong>*</strong>}
          {this.props.titleAddition}
        </Accordion.Title>
        <Accordion.Content active={isAccordionActive} disabled={true} className={contentClassName}>
          {this.props.render({...this.props, isAccordionActive})}
        </Accordion.Content>
      </Accordion>
    );
  }
}

AccordionWrapper.propTypes = {
  accordionTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  render: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
  closable: PropTypes.bool,
  isRequired: PropTypes.bool.isRequired,
  isContentLoading: PropTypes.bool,
};

AccordionWrapper.defaultProps = {
  closable: true,
  collapsed: false,
  isRequired: false,
  titleAddition: null,
  icon: null,
  isContentLoading: false,
};

export default withTranslation()(AccordionWrapper);
